import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { URI } from '@fiverr-private/futile';
import { OPEN_GIG_SAME_TAB_TARGET } from '../constants';
import { useGigListingsContext } from '../../../GigCardListings/context/GigListingsContext';
import { useCardContext } from '../../../GigCardListings/context/CardContext';

const ContextualLink = ({
    href,
    title = '',
    rel = '',
    onMouseDown,
    onMouseEnter,
    onMouseLeave,
    className,
    target,
    ariaLabel,
    auctionId = null,
    children,
}) => {
    const { urlTarget } = useGigListingsContext();
    const { impressionId } = useCardContext();
    const linkTarget = urlTarget || target || OPEN_GIG_SAME_TAB_TARGET;
    const contextualUrl = new URI(href).addParams({
        imp_id: impressionId,
    }).href;

    const handleClick = useCallback(
        (e) => {
            e.preventDefault();

            const url = new URL(contextualUrl, window.location.origin);
            if (auctionId) {
                url.searchParams.set('ad_key', auctionId);
            }

            window.open(url.toString(), '_blank');
        },
        [contextualUrl, auctionId]
    );

    return (
        <a
            href={contextualUrl}
            target={linkTarget}
            aria-label={ariaLabel}
            className={className}
            title={title}
            rel={rel}
            onMouseDown={onMouseDown}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={handleClick}
        >
            {children}
        </a>
    );
};

ContextualLink.propTypes = {
    children: PropTypes.any,
    className: PropTypes.any,
    onMouseDown: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    rel: PropTypes.any,
    title: PropTypes.any,
    href: PropTypes.any,
    target: PropTypes.any,
    ariaLabel: PropTypes.string,
    auctionId: PropTypes.string,
};

export default ContextualLink;
